/*------------------------------------*\
    Email Validation
\*------------------------------------*/
class EmailValidation {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        const emailValidation = document.getElementById('emailValidate');

        emailValidation.addEventListener('click', (evt) => {
            evt.preventDefault();

            // self.validateEmail();
            self.validateFirstName();
            self.validateLastName();
            self.validatePostcode();
            // self.validateStayInformed();
        });
    }

    // validateEmail() {
    //     const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    //     const inputText = document.getElementById("15-email").value.trim();

    //     if (inputText === '' || !inputText.match(mailformat)) {
    //         document.getElementById('email-feedback').classList.add('d-block');
    //         document.getElementById('15-email').style.borderColor = "#dc3545";
    //         return false;
    //     }

    //     return true;
    // }

    validateFirstName() {
        const inputText = document.getElementById("10-first_name").value.trim();


        if (inputText === '') {
            document.getElementById('first-name-feedback').classList.add('d-block');
            document.getElementById('10-first_name').style.borderColor = "#dc3545";
            return false;
        }
    }

    validateLastName() {
        const inputText = document.getElementById("11-last_name").value.trim();

        if (inputText === '') {
            document.getElementById('last-name-feedback').classList.add('d-block');
            document.getElementById('11-last_name').style.borderColor = "#dc3545";
            return false;
        }
    }

    validatePostcode() {
        const inputText = document.getElementById("13-postcode").value.trim();

        if (inputText === '') {
            document.getElementById('postcode-feedback').classList.add('d-block');
            document.getElementById('13-postcode').style.borderColor = "#dc3545";
            return false;
        }
    }

    // validateStayInformed() {
    //     const yesRadio = document.getElementById('yes');
    //     const noRadio = document.getElementById('no');

    //     if (!yesRadio.checked && !noRadio.checked) {
    //         document.getElementById('stay-informed-feedback').classList.add('d-block');
    //         return false;
    //     }

    //     return true;
    // }
}

export default EmailValidation;